var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0464 17.2351C16.7921 16.9818 16.3805 16.9826 16.1272 17.2369C15.8739 17.4913 15.8747 17.9028 16.129 18.1562L17.0464 17.2351ZM22.5413 24.5431C22.7956 24.7964 23.2072 24.7956 23.4605 24.5413C23.7139 24.2869 23.7131 23.8754 23.4587 23.6221L22.5413 24.5431ZM19.2071 10.3913C19.2071 15.2166 15.2793 19.1326 10.4286 19.1326V20.4326C15.9924 20.4326 20.5071 15.9394 20.5071 10.3913H19.2071ZM10.4286 19.1326C5.57787 19.1326 1.65 15.2166 1.65 10.3913H0.35C0.35 15.9394 4.86476 20.4326 10.4286 20.4326V19.1326ZM1.65 10.3913C1.65 5.56604 5.57787 1.65 10.4286 1.65V0.35C4.86476 0.35 0.35 4.84322 0.35 10.3913H1.65ZM10.4286 1.65C15.2793 1.65 19.2071 5.56604 19.2071 10.3913H20.5071C20.5071 4.84322 15.9924 0.35 10.4286 0.35V1.65ZM16.129 18.1562L22.5413 24.5431L23.4587 23.6221L17.0464 17.2351L16.129 18.1562Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.669d7b421c57e16a99a3d87525284349.svg";
export { ForwardRef as ReactComponent };